import type { RichText } from "@storytell/cp-client";
import { RichTextType } from "@storytell/types/richText";

/**
 * Extracts the title from a RichText document by finding the first heading.
 *
 * @param richText - The RichText document to extract the title from
 * @returns The text of the first heading, or undefined if no heading is found
 */
export const findTitle = (richText: RichText.RichText): string | undefined => {
  return richText.content
    .find((node) => node.type === RichTextType.HeadingType)
    ?.content.find((node) => node.type === RichTextType.TextType)?.text;
};
